import React from "react";
import styled from "styled-components";
import "react-social-icons/instagram";

const Wrapper = styled.section`
  padding: 5%;
  margin-top: 40%;
  @media (min-width: 568px) {
    margin-top: 10%;
  }
  text-align: center;
  *, *::before, *::after {
    box-sizing: border-box;
  }
  p {
    font-family: ${(props) => props.theme.fam.regular};
  }
  h2 {
    margin-top: 5%;
    padding-bottom: 10%;
    font-family: ${(props) => props.theme.fam.medium};
  }
  .images {
    /* display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: column; */
    gap: 16px;
    .col1,
    .col2,
    .col3,
    .col4,
    .imgs {
      display: none;
    }
    .display,
    .imgs {
      gap: 16px;
      display: grid;
    }
    .display {
      @media (min-width: 568px) {
        display: flex;
        margin: 0;
        .imgs {
          display: flex;
          justify-content: flex-start;
          align-items: stretch;
          flex-direction: column;
          gap: 16px;
        }
      }
    }
    .first {
      display: grid;
      gap: 16px;
    }
    .second,
    .first {
      .image-h,
      .image {
        position: relative;
        overflow: hidden;
        border-radius: 8px;
        img {
          display: block;
          width: 100%;
          height: auto;
        }
        .text {
          position: absolute;
          inset: 0;
          background: rgba(77, 134, 201, 0.85);
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 16px;
          font-size: clamp(12px, 1.1vw, 14px);
          opacity: 0;
          transition: opacity 200ms ease;
          p {
            display: block;
            margin: 0;
            max-width: 42ch;
            text-align: center;
            overflow: hidden;
            display: -webkit-box;
            -webkit-line-clamp: 5;
            -webkit-box-orient: vertical;
          }
          .t {
            line-height: 1.4;
          }
        }
        &:hover {
          .text {
            opacity: 1;
            color: #fff;
          }
        }
      }
    }
  }

  @media (min-width: 768px) {
    margin-top: 3%;
    h2 {
      padding-bottom: 1%;
    }
    .images {
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      gap: 16px;
      .first {
        margin-top: 5%;
        display: flex;
        justify-content: flex-start;
        .display {
          width: 100%;
          flex-direction: column;
          .image-h {
            width: 100%;
            .img-t {
              height: 100%;
              width: 100%;
              img {
                width: 100%;
              }
            }
          }
          .imgs {
            flex-direction: row;
            width: 100%;
            gap: 16px;
            .image-h {
              width: 100%;
              img {
                width: 100%;
              }
            }
          }
        }
        .c2 {
          display: grid;
          gap: 16px;
          width: 48.5%;
        }
        .col3 {
          display: grid;
          gap: 16px;
          width: 100%;
          .image-h {
            width: 100%;
            .img-t {
              width: 100%;
              img {
                width: 100%;
              }
            }
          }
          .imgs {
            display: flex;
            justify-content: flex-start;
            align-items: stretch;
            gap: 16px;
            width: 100%;
            .image {
              width: unset;
              img {
                width: 100%;
              }
            }
          }
        }
      }
      .second {
        width: 53%;
      }
    }
  }

  @media (min-width: 992px) {
    margin-top: 5%;
    h2 {
      font-size: 45px;
      margin-top: 0%;
      padding-bottom: 0;
    }

    .images {
      .first {
        width: 100%;

        .col1,
        .col3 {
          width: 80.6%;
        }
        .col2,
        .col4 {
          display: grid;
          width: 39%;
          gap: 2%;
        }
      }
      .second {
        width: 100%;
      }
    }
  }
  @media (min-width: 1200px) {
    padding: 0 10%;
    margin-top: 15%;
    .blog-inner {
      h2 {
        font-size: 40px;
        margin-top: 2%;
      }
      .images {
        .first {
          width: 100%;

          .col1,
          .col3 {
            width: 80.6%;
          }
          .col2,
          .col4 {
            display: grid;
            width: 39%;
            gap: 2%;
          }
        }
        .second {
          width: 100%;
        }
      }
    }
  }
`;

function Blog() {
  return (
    <Wrapper>
      <div className="blog-inner">
        <p>Follow us on instagram</p>
        <h2>@jumpstart</h2>
        <div className="images">
          <div className="first">
            <div className="col1 display">
              <div className="image-h">
                <div className="img-t">
                  <img src="/images/img1.png" alt="image1" />
                </div>
                <div className="text">
                  <p className="t">
                    For schools which do not have a regular counsellor, we offer
                    counselling services within your school based on your needs
                    within your student, staff or parent community.
                  </p>
                  {/* <SocialIcon url="www.instagram.com" /> */}
                </div>
              </div>

              <div className="imgs">
                <div className="image-h">
                  <img src="/images/img6.png" alt="image6" />
                  <div className="text">
                    <p className="t">
                      For schools which do not have a regular counsellor, we offer
                      counselling services within your school based on your needs
                      within your student, staff or parent community.
                    </p>
                  </div>
                </div>
                <div className="image-h">
                  <img src="/images/img7.png" alt="image7" />
                  <div className="text">
                    <p className="t">
                      For schools which do not have a regular counsellor, we offer
                      counselling services within your school based on your needs
                      within your student, staff or parent community.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col2 none c2">
              <div className="image-h">
                <img src="/images/img2.png" alt="image2" />
                <div className="text">
                  <p className="t">
                    For schools which do not have a regular counsellor, we offer
                    counselling services within your school based on your needs
                    within your student, staff or parent community.
                  </p>
                </div>
              </div>
              <div className="image-h">
                <img src="/images/img8.png" alt="image8" />
                <div className="text">
                  <p className="t">
                    For schools which do not have a regular counsellor, we offer
                    counselling services within your school based on your needs
                    within your student, staff or parent community.
                  </p>
                </div>
              </div>
              <div className="image-h">
                <img src="/images/img9.png" alt="image9" />
                <div className="text">
                  <p className="t">
                    For schools which do not have a regular counsellor, we offer
                    counselling services within your school based on your needs
                    within your student, staff or parent community.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="first second">
            <div className="col3 none">
              <div className="imgs las">
                <div className="image">
                  <img src="/images/img3.png" alt="image3" />
                  <div className="text">
                    <p className="t">
                      For schools which do not have a regular counsellor, we offer
                      counselling services within your school based on your needs
                      within your student, staff or parent community.
                    </p>
                  </div>
                </div>
                <div className="image">
                  <img src="/images/img4.png" alt="image4" />
                  <div className="text">
                    <p className="t">
                      For schools which do not have a regular counsellor, we offer
                      counselling services within your school based on your needs
                      within your student, staff or parent community.
                    </p>
                  </div>
                </div>
              </div>
              <div className="image-h">
                <div className="img-t">
                  <img src="/images/a.png" alt="image1" />
                </div>
                <div className="text">
                  <p className="t">
                    For schools which do not have a regular counsellor, we offer
                    counselling services within your school based on your needs
                    within your student, staff or parent community.
                  </p>
                  {/* <SocialIcon url="www.instagram.com" /> */}
                </div>
              </div>
            </div>
            <div className="col4 none">
              <div className="image-h">
                <img src="/images/img5.png" alt="image5" />
                <div className="text">
                  <p className="t">
                    For schools which do not have a regular counsellor, we offer
                    counselling services within your school based on your needs
                    within your student, staff or parent community.
                  </p>
                </div>
              </div>
              <div className="image-h">
                <img src="/images/img10.png" alt="image10" />
                <div className="text">
                  <p className="t">
                    For schools which do not have a regular counsellor, we offer
                    counselling services within your school based on your needs
                    within your student, staff or parent community.
                  </p>
                </div>
              </div>
              <div className="image-h">
                <img src="/images/img11.png" alt="image11" />
                <div className="text">
                  <p className="t">
                    For schools which do not have a regular counsellor, we offer
                    counselling services within your school based on your needs
                    within your student, staff or parent community.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Wrapper>
  );
}

export default Blog;
